import '../styles/globals.css'
import '../../MyStichtingOpenComponents/src/index.scss'
import '../types/yup/yupExtensions'

import Logger from '../helpers/logger'
import { AppProvider } from '../providers/app-provider'
import { ChamberOfCommerceProvider } from '../providers/chamber-of-commerce-provider'
import { LocaleProvider } from '../providers/locale-provider'
import { RegistrationDataProvider } from '../providers/registration-data-provider/registration-data-provider'
import { UserInteractivityProvider } from '../providers/user-interactivity-provider'
import { DictionariesByLocale, Dictionary } from '../../MyStichtingOpenHelpers/src'
import type { AppContext, AppProps } from 'next/app'
import App, { AppInitialProps } from 'next/app'
import { TRANSLATIONS_ENDPOINT } from '../constants/translationsConstants'
import getConfig from 'next/config'
import { DictionaryProviderWrapper } from '../providers/DictionaryProviderWrapper'
import { UserProvider } from '../providers/user-provider'

export interface MyAppProps extends AppProps {
    pageProps: {
        dictionariesByLocale: DictionariesByLocale
    }
}

const MyApp = ({ Component, pageProps }: MyAppProps): JSX.Element => {
    if (!pageProps?.dictionariesByLocale) {
        Logger.warn('Translations could not be loaded.')
    }

    return (
        <div className="bg-shade-100 inset-0 absolute">
            <UserProvider>
                <LocaleProvider>
                    <DictionaryProviderWrapper dictionariesByLocale={pageProps.dictionariesByLocale}>
                        <UserInteractivityProvider>
                            <RegistrationDataProvider>
                                <ChamberOfCommerceProvider>
                                    <AppProvider>
                                        <Component {...pageProps} />
                                    </AppProvider>
                                </ChamberOfCommerceProvider>
                            </RegistrationDataProvider>
                        </UserInteractivityProvider>
                    </DictionaryProviderWrapper>
                </LocaleProvider>
            </UserProvider>
            <div id="context-menu-root" />
            <div id="modal-root" />
        </div>
    )
}

MyApp.getInitialProps = async (appContext: AppContext): Promise<MyAppProps> => {
    const appProps: AppInitialProps = await App.getInitialProps(appContext)
    const returnProps: any = { ...appProps, pathname: appContext.ctx.pathname }
    const { publicRuntimeConfig } = getConfig()

    const translationsURL = TRANSLATIONS_ENDPOINT(publicRuntimeConfig.NEXT_PUBLIC_API_GATEWAY_BASEURL)
    const dictionariesByLocale: DictionariesByLocale | null | unknown =
        await Dictionary.fetchMultipleDictionaries(translationsURL)

    returnProps.pageProps.dictionariesByLocale = dictionariesByLocale ?? {}

    return returnProps
}

export default MyApp
